// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"13bbbe5c098748f4","76":"ad42dca7e61b016c","331":"3404cc7e89e1bbea","489":"cc62f21220ba8bff","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};